import VectorAIBase from "./vectorai-base.service";

class AuthService extends VectorAIBase {
  public isAuthenticated() {
    return Boolean(this.getAuth().api_key && this.getAuth().username);
  }
}

export default new AuthService();
